import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ScrollableFilterBar } from './ScrollableFilterBar';
import { NavRenderer } from './NavRenderer';
import { useChildComponentExtractor } from './useChildComponentExtractor';

/**
 * @param {object} props - Props.
 * @returns {React.Element} Component.
 */
export const StatsSectionNav = (props) => {
    const [areFilterOptionsVisible, setAreFilterOptionsVisible] =
        useState(true);

    const {
        navItems,
        filterItems,
        additionalNavItems,
        roundButtons,
        settingsButton,
        responsiveRowItems,
        searchBarMobile
    } = useChildComponentExtractor(props.children);

    const isFiltersVisibleHandler = () => {
        setAreFilterOptionsVisible((prev) => !prev);
    };

    const renderNavItems = (
        <NavRenderer
            navItems={navItems}
            filterItems={filterItems}
            settingsButton={settingsButton}
            additionalNavItems={additionalNavItems}
            roundButtons={roundButtons}
            isFiltersVisibleHandler={isFiltersVisibleHandler}
            withScrollableFilter={props.withScrollableFilter}
            showResponsiveItems={props.showResponsiveItems}
        />
    );

    return (
        <div className="u-stats-shadow" style={{ marginBottom: '1.6rem' }}>
            <div
                className={`stats-leaders-nav ${props.className || ''} ${
                    navItems?.props?.children?.length > 1
                        ? 'multiple-filter-items'
                        : ''
                }`}
            >
                {props.withScrollableFilter ? (
                    <ScrollableFilterBar
                        settingsButton={settingsButton}
                        roundButtons={roundButtons}
                    >
                        {renderNavItems}
                    </ScrollableFilterBar>
                ) : (
                    renderNavItems
                )}
            </div>

            <div
                className={`${
                    !areFilterOptionsVisible && !props.showFilterItems
                        ? 'u-hide'
                        : ''
                }`}
            ></div>

            {!!responsiveRowItems && (
                <div className="stats-leaders-nav__responsive-row-items">
                    {responsiveRowItems}
                </div>
            )}

            {!!searchBarMobile && (
                <div className="stats-leaders-nav__search-bar--mobile">
                    {searchBarMobile}
                </div>
            )}
        </div>
    );
};

StatsSectionNav.defaultProps = {
    name: 'StatsSectionNav'
};

StatsSectionNav.propTypes = {
    children: PropTypes.any,
    onclick: PropTypes.func,
    isOpen: PropTypes.bool,
    showFilterItems: PropTypes.bool,
    showFilterLabel: PropTypes.bool,
    withScrollableFilter: PropTypes.bool,
    showResponsiveItems: PropTypes.bool,
    className: PropTypes.string
};
